export const ClientSeasonApiRoute = {
  GetClientSeason: (clientId: string) => `/cockpit-api/clients/${clientId}/client-season`,
} as const;
